import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface IHeaderProps extends ITestableComponentProps {
  isMobile?: boolean;
}

export const DefaultHeaderProps = {
  isMobile: false,
};
